import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { VesselDataPayload, VesselDataResponse } from "@/types/interface/vessel";

async function createVessel(payload: VesselDataPayload) {
  return await http.post<APIResponse<VesselDataResponse>>("vessel/create", payload);
}

async function updateVessel(idVessel = '', payload: VesselDataPayload) {
  return await http.patch<APIResponse<VesselDataResponse>>(`vessel/update?id=${idVessel}`, payload);
}

async function getVessel(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  return await http.get<APIResponse<VesselDataResponse>>(`vessel?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function findVessel(idVessel = "") {
  return await http.get<APIResponse<VesselDataResponse>>(`vessel/detail?id=${idVessel}`);
}

async function deleteVessel(idVessel = "") {
  return await http.delete<APIResponse<VesselDataResponse>>(`vessel/delete?id=${idVessel}`);
}

export default {
  createVessel,
  updateVessel,
  getVessel,
  findVessel,
  deleteVessel
};